// extracted by mini-css-extract-plugin
module.exports = {"container":"safe-build_container_2eGun","noDataBox":"safe-build_noDataBox_3Mm6L","icon":"safe-build_icon_E4YhR","chartBox":"safe-build_chartBox_2Q1XK"};